/**
 * Created by razial on 21.08.2025.
 */

const MigrationNoticeWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            title: Messages.get("MigrationNoticeWindow.title"),
            name: "migrationnoticewindow",
            content: this.getContent(),
            button: {
                width: cleverapps.styles.MigrationNoticeWindow.button.width,
                height: cleverapps.styles.MigrationNoticeWindow.button.height,
                text: Messages.get("MigrationNoticeWindow.play"),
                onPressed: function () {
                    this.close();
                }.bind(this)
            }
        });
    },

    getContent: function () {
        const styles = cleverapps.styles.MigrationNoticeWindow;
        const image = new cc.Sprite(bundles.migration_notice_window.frames.renovation_window_png);
        const elements = [image, this.getText()];

        return new cleverapps.Layout(elements, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    getText: function () {
        const styles = cleverapps.styles.MigrationNoticeWindow.text;
        const items = [];

        for (let i = 0; i < 3; i++) {
            items.push(this.getTextItem(i));
        }

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    getTextItem: function (item) {
        const styles = cleverapps.styles.MigrationNoticeWindow.text;
        const text = cleverapps.UI.generateOnlyText(Messages.get(`MigrationNoticeWindow.text.item${item}`), cleverapps.styles.FONTS.MIGRATION_NOTICE_WINDOW_TEXT);
        text.setDimensions(styles.width, 0);

        const checkMark = new cc.Sprite(bundles.migration_notice_window.frames.check_mark_png);
        checkMark.setAnchorPoint(0.5, 1);
        text.setAnchorPoint(0.5, 1);

        const layout = new cleverapps.Layout([checkMark, text], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        layout.setAnchorPoint(0, 0.5);

        return layout;
    },

    listBundles: function () {
        return ["migration_notice_window"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MIGRATION_NOTICE_WINDOW_TEXT: {
        size: 40,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.MigrationNoticeWindow = {
    margin: 35,

    text: {
        margin: 20,
        width: 900
    },

    button: {
        width: 300,
        height: 100
    }
};
